import styled from 'styled-components';
import {ButtonBase} from '../../../CommonStyleUtils/dwebCommon.styles';

export const SoldOutWrapper = styled.div(
  props => `
      flex: 1;
      width: 50%;
      border: 1px solid #E5EDF6;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: ${props.theme.colors.goRed.light};
    `,
);

export const SoldOutDescWrapper = styled.div(
  props => `
    margin: 12px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    max-width: 500px;
  `,
);

export const Button = styled(ButtonBase)(
  props => `
    height:4rem;
    width:100%;
    border-radius: ${props.theme.misc.borderRadius.custom(8)};
    cursor: pointer;
    text-transform: capitalize;
  `,
);
